import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen(!menuOpen);

  const navLinkClass = "inline-block rounded-lg px-2 py-1 text-sm font-medium text-gray-900 transition hover:bg-gray-100";

  return (
    <header className="fixed inset-x-0 top-0 z-30 mx-auto w-full max-w-screen-md border border-gray-100 bg-white py-3 shadow backdrop-blur-lg md:top-6 md:rounded-3xl lg:max-w-screen-lg mb-10">
      <div className="px-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex shrink-0">
            <a href="#home" className="flex items-center">
              <img
                className="h-7 w-auto"
                src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1744174245/J_Mills_Logo_Illustration_hinhst.png"
                alt="Jayamal Oil Mills Logo"
              />
              <p className="sr-only">Jayamal Oil Mills</p>
            </a>
          </div>

          {/* Mobile Toggle */}
          <div className="md:hidden">
            <button onClick={toggleMenu} className="text-gray-700 hover:text-gray-900 focus:outline-none">
              {menuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex md:items-center md:gap-5">
            <a href="#home" className={navLinkClass}>Home</a>
            <a href="#products" className={navLinkClass}>Products</a>
            <a href="#about" className={navLinkClass}>About Us</a>
            <a href="#contact" className={navLinkClass}>Contact Us</a>
          </nav>
        </div>

        {/* Mobile Menu */}
        {menuOpen && (
          <div className="mt-3 flex flex-col items-start space-y-2 md:hidden">
            <a href="#home" onClick={toggleMenu} className={navLinkClass}>Home</a>
            <a href="#products" onClick={toggleMenu} className={navLinkClass}>Products</a>
            <a href="#about" onClick={toggleMenu} className={navLinkClass}>About Us</a>
            <a href="#contact" onClick={toggleMenu} className={navLinkClass}>Contact Us</a>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
